import React from 'react'
import PropTypes from 'prop-types'

import { Transition } from 'react-transition-group'

// styles
import style from '@aytm/app/stats/page/sidebar/reports/styles/ReportPopup.module.scss'

// Max height of an expanded section body; longer content scrolls inside it.
const BODY_MAX_HEIGHT = 360

// Collapsible accordion section for the report-popup description column: a clickable
// header (label + chevron) over a Transition-animated body. The parent owns which
// section is open so only one is expanded at a time (accordion). A section with no body
// is not rendered at all -- a header that opens onto nothing reads as a broken control.
const ReportPopupSection = ({ title, open, onToggle, children }) =>
  0 === React.Children.count(children) ? null : (
    <div className={style['description-content-section']}>
      <div
        className={`${style['description-content-section-head']}${
          open ? '' : ' ' + style['description-content-section-head-collapsed']
        }`}
        onClick={onToggle}
      >
        <span>{title}</span>
        <i className="icon-aytmfd-chevron-bracket" />
      </div>
      <Transition in={open} timeout={500}>
        {status => (
          <div
            className={`${style['description-content-section-body']}${
              status ? ' ' + style['description-content-section-body-' + status] : ''
            }`}
            style={{ maxHeight: open ? BODY_MAX_HEIGHT : 0 }}
          >
            <div className={style['description-content-section-body-content']}>{children}</div>
          </div>
        )}
      </Transition>
    </div>
  )

ReportPopupSection.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node
}

ReportPopupSection.displayName = 'ReportPopupSection'

export default ReportPopupSection
